<template>
    <div class="charge-warp" v-loading="loading">
        <div class="display-f just-b">
            <el-form ref="form" :model="searchForm" label-width="55px" inline>
                <el-form-item label="日期：">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="searchForm.date" type="datetimerange"  :default-time="['00:00:00', '23:59:59']"
                        :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-input style="width: 128px;" placeholder="收费员" v-model="searchForm.saleName"></el-input>
                </el-form-item>
                <el-form-item>
                    <custom-button type="primary" @click="handleSearch">查询</custom-button>
                    <custom-button type="" @click="reset">重置</custom-button>
                </el-form-item>
            </el-form>
            <custom-button type="primary" plain @click="handleExport">导出</custom-button>
        </div>
        <div class="table-warp">
            <customTable height="700" :cell-style="{ borderColor: '#DDDDDD' }" :showPages="false" :tableData="tableData"
                :column="column" :total="total" :currentPage="searchForm.pageNum"
                :header-cell-style="{ background: '#F0F1F3', borderColor: '#DDDDDD' }" border>
                <template slot="collect">
                    <div class="tac">账目汇总</div>
                    <div class="payWay-warp mt20">
                        <div class="payWay-item w160">总收入 <el-tooltip class="item" effect="dark" content="当收费合计 - 退费合计"
                                placement="top-start">
                                <i class="el-icon-question"></i>
                            </el-tooltip></div>
                        <div class="payWay-item w160">收费 </div>
                        <div class="payWay-item w160">退费</div>
                    </div>
                </template>
                <template slot="payWay">
                    <div class="tac">支付方式（包含挂号费+营业费）</div>
                    <div class="payWay-warp mt20">
                        <div v-for="item in payWayList" :key="item.value" class="payWay-item w142">{{ item.label }}</div>
                    </div>
                </template>
                <template slot-scope="scope" slot="collectAmount">
                    <div class="payWay-warp">
                        <div class="payWay-item w160">{{ scope.row.totalMoney }}</div>
                        <div class="payWay-item w160">{{ scope.row.totalIncome }}</div>
                        <div class="payWay-item w160">{{ scope.row.totalRefund }}</div>
                    </div>
                </template>
                <template slot-scope="scope" slot="payWayAmount">
                    <div class="payWay-warp">
                        <div class="payWay-item w142" v-for="item in payWayList" :key="item.value">
                            <span v-if="item.value == '1'">{{ scope.row.ybMoney }}</span>
                            <span v-if="item.value == '2'">{{ scope.row.cashMoney }}</span>
                            <span v-if="item.value == '3'">{{ scope.row.howMuchMoney }}</span>
                            <span v-if="item.value == '4'">{{ scope.row.weChatMoney }}</span>
                            <span v-if="item.value == '5'">{{ scope.row.aliPayMoney }}</span>
                            <span v-if="item.value == '6'">{{ scope.row.bankCardMoney }}</span>
                            <span v-if="item.value == '7'">{{ scope.row.abcMoney }}</span>
                            <span v-if="item.value == '8'">{{ scope.row.walletMoney }}</span>
                            <span v-if="item.value == '9'">{{ scope.row.meituanMoney }}</span>
                            <span v-if="item.value == '10'">{{ scope.row.chequeMoney }}</span>
                            <span v-if="item.value == '12'">{{ scope.row.vipCardMoney }}</span>
                            <span v-if="item.value == '13'">{{ scope.row.jykMoney }}</span>
                            <span v-if="item.value == '14'">{{ scope.row.ybLineMoney }}</span>
                        </div>
                    </div>
                </template>
            </customTable>
        </div>
    </div>
</template>
  
<script>
import customTable from '@/components/customTable/customTable'
import { Utils } from '@/utils/utils'
import moment from 'moment';
import { statementDTO, CommonDTO } from '@/DTO/index'
import { debounce, isMoreThanOneYear } from '@/utils/validateBase'
export default {
    // 定义引入的组件
    components: { customTable },
    props: {},
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '今日',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '昨日',
                    onClick(picker) {
                        let yesterday = moment().subtract(1, 'days')
                        const end = Utils.timeFormat(Number(Utils.endOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '本周',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '本月',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('month'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('month'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '本年',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('year'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('year'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                ]
            },
            searchForm: {
                date: [],
                payWay: '',
                saleName: '',
                deptId: this.$session.get('deptId'),
            },
            loading: false,
            tableData: [],
            total: 0,
            column: [
                { label: "收费员", prop: "saleName", width: 159, align: 'left' },
                { label: "账目汇总", width: 445, slotHeader: 'collect', slotName: 'collectAmount', align: 'left' },
                { label: "支付方式（包含挂号费+营业费）", slotHeader: 'payWay', slotName: 'payWayAmount', align: 'left' },
            ],
            payWayList: [],//支付方式列表(含医保)
            payWayListSelect: [],
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    async created() {
        this.init()
        this.payWayList = await CommonDTO.getPayWay()
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 初始化数据
         */
        async init() {
            let time = CommonDTO.getSystemTimeDTO()
            let startOfDay = Number(Utils.startOfDay(this.$moment(time)))
            let endOfDay = Number(Utils.endOfDay(this.$moment(time)))
            this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD HH:mm:ss')
            this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD HH:mm:ss')
            this.getCashier()
        },
        /**
         * 搜索
         */
        handleSearch() {
            if(_.isEmpty(this.searchForm.date)){
                this.$message.error('请选择时间')
                return
            }
            let flag = this.searchForm.date&&isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 366)
            if (flag) return this.$message.error('时间范围不能超过一年')
            // let HH = this.$moment().get('hour')
            // let flagOneDay = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 1)
            // if(flagOneDay && HH < 22 && HH > 7 ) return this.$message.error('当前选择的日期范围大于1天，请22:00后查询')
            this.getCashier()
        },
        /**
         * 重置
         */
        reset() {
            this.searchForm = {
                date: [],
                payWay: '',
                saleName: '',
                deptId: this.$session.get('deptId'),
            }
            this.init()
        },

        /**
         * 查询日报
         */
        getCashier() {
            this.loading = true
            this.searchForm.startDate = this.searchForm.date&&Utils.timeFormat(this.searchForm.date[0], 'yyyy-MM-DD HH:mm:ss')
            this.searchForm.endDate = this.searchForm.date&&Utils.timeFormat(this.searchForm.date[1], 'yyyy-MM-DD HH:mm:ss')
            statementDTO.getCashier(this.searchForm).then(res => {
                this.loading = false
                let { code, data } = res
                if (code == 200) {
                    this.tableData = data
                }
            }).catch(() => {
                this.loading = false
            })
        },
        /**
         * 导出
         */
        handleExport: debounce(function () {
            this.searchForm.startDate = this.searchForm.date&&Utils.timeFormat(this.searchForm.date[0], 'yyyy-MM-DD HH:mm:ss')
            this.searchForm.endDate = this.searchForm.date&&Utils.timeFormat(this.searchForm.date[1], 'yyyy-MM-DD HH:mm:ss')
            this.loading = true
            statementDTO.cashierExport(this.searchForm, { name: '收费员统计' }).then(res => {
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
        }, 1000, true),
    },
}
</script>
<style lang="less" scoped>
.charge-warp {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .el-form-item {
        margin-bottom: 0;
    }

    .table-warp {
        margin-top: 16px;
        flex: 1;

        /deep/.el-table {
            border-color: #DDDDDD;
        }
         /deep/.el-table__row{
            &:last-child{
                .cell{
                    font-weight: 600 !important;
                color: #1F2329 !important;
                }
                font-weight: 600 !important;
                color: #1F2329 !important;
            }
        }
        .payWay-warp {
            display: flex;

            .payWay-item {
                box-sizing: border-box;
            }
        }
    }
}</style>